export enum SmartCullMode {
    VISIBLE,
    ALPHA
}

/**
 * Cull renderables even items within containers if outside of rectangle
 * - cull sets visible to true/false. visible and alpha are used in renderFlags, so its simplest to use one of those. Shoild still take care not using those elsewhere while being culled then.
 * 
 * NOTE: when using SmartCull to visible=true|false items, use alpha to show/hide such items outside of smartcull culling. Or alternativelly use alpha by smartCull and visible by the items outside of SmartCull.
 */
export class SmartCull {
    public static mode: SmartCullMode

    /**
     * Culls once. Call this OEF to cull as things are repositioning.
     * 
     * @param rect 
     * @param items 
     */
    public static Cull(
        rect: Phaser.Geom.Rectangle, 
        items: Phaser.GameObjects.GameObject[],
        mode: SmartCullMode = SmartCullMode.VISIBLE,
    ): void
    {
        items.forEach((item:Phaser.GameObjects.Image, i)=>{
            if (item.getBounds) {
                if (mode = SmartCullMode.ALPHA) {
                    item.alpha = Phaser.Geom.Intersects.RectangleToRectangle(rect, item.getBounds()) ? 1 : 0;
                }
                else {
                    item.visible = Phaser.Geom.Intersects.RectangleToRectangle(rect, item.getBounds());
                }
            }
        });
    }
}